import gql from 'graphql-tag'

export const TIMELINE_EXPIRED_CASHBACK_METRICS = gql`
  query TimelineCashbackMetrics($groupBy: MetricGranularity, $filters: [CashbackFilter!]!) {
    timelineCashbackMetrics(groupBy: $groupBy, filters: $filters) {
      data {
        label
        consumedCashbackMetric
        acquiredCashbackMetric
        expiredCashbackMetric
      }
    }
  }
`
export const TIMELINE_FUTURE_CASHBACK_METRICS = gql`
  query FutureCashbackExpirationsMetric($groupBy: MetricGranularity, $filters: [CashbackFilter!]!) {
    futureCashbackExpirationsMetric(groupBy: $groupBy, filters: $filters) {
      data {
        label
        futureCashbackExpirationsMetric
      }
    }
  }
`

export const ACTIVE_CASHBACK_METRIC = gql`
  query ActiveCashbackMetric {
    activeCashbackMetric {
      value
      expires_current_month
    }
  }
`

export const CUSTOMERS_WITH_CASHBACK_METRIC = gql`
  query CustomersWithCashbackMetric {
    customersWithCashbackMetric {
      value
    }
  }
`

export const CUSTOMERS_USING_CASHBACK_METRIC = gql`
  query CustomersUsingCashbackMetric {
    customersUsingCashbackMetric {
      value
      details
    }
  }
`

export const CONSUMED_CASHBACK_METRIC = gql`
  query ConsumedCashbackMetric {
    consumedCashbackMetric {
      value
      details
    }
  }
`

export const TABULAR_CONSUMED_CASHBACK = gql`
  query TabularConsumedCashback(
    $filters: [CashbackFilter!]!
    $search: String
    $sort: [SortableField!]
    $sortDirection: [SortDirection!]
    $pageSize: Float
    $page: Float
  ) {
    tabularConsumedCashback(filters: $filters, search: $search, sort: $sort, sortDirection: $sortDirection, pageSize: $pageSize, page: $page) {
      page
      records
      data {
        customer {
          COD_ID_CLIENTE
          NUM_CPF_CNPJ
          NOM_NOME
        }
        store {
          COD_ID_LOJA
          NOM_NOME
        }
        cashback
        date
      }
    }
  }
`

export const TABULAR_DISTRIBUTED_CASHBACK = gql`
  query TabularDistributedCashback(
    $filters: [CashbackFilter!]!
    $search: String
    $sort: [SortableField!]
    $sortDirection: [SortDirection!]
    $pageSize: Float
    $page: Float
  ) {
    tabularDistributedCashback(filters: $filters, search: $search, sort: $sort, sortDirection: $sortDirection, pageSize: $pageSize, page: $page) {
      page
      records
      data {
        product {
          COD_ID_PRODUTO
          DES_PRODUTO
          NUM_UNIDADE_COM_CASHBACK
        }
        customer {
          COD_ID_CLIENTE
          NUM_CPF_CNPJ
          NOM_NOME
        }
        store {
          COD_ID_LOJA
          NOM_NOME
        }
        cashback
        date
        expires_at
      }
    }
  }
`

export const QUERY_GET_CASHBACK_ADJUSTMENTS = gql`
  query CashbackAdjustments($search: String, $sort: [CashbackAdjustmentSortableField!], $sortDirection: [SortDirection!], $pageSize: Float, $page: Float) {
    cashbackAdjustments(search: $search, sort: $sort, sortDirection: $sortDirection, pageSize: $pageSize, page: $page) {
      page
      records
      cashback_adjustments {
        user {
          _id
          document_no
          name
        }
        adjusted_by {
          login
        }
        adjustment_reason
        adjustment_amount
        previous_inactive_cashback
        final_inactive_cashback
        created_at
        expires_at
      }
    }
  }
`

export const QUERY_GET_CASHBACK_BALANCE_LOCKS = gql`
  query CashbackBalanceLocks($search: String, $sort: [CashbackBalanceLockSortableField!], $sortDirection: [SortDirection!], $pageSize: Float, $page: Float) {
    cashbackBalanceLocks(search: $search, sort: $sort, sortDirection: $sortDirection, pageSize: $pageSize, page: $page) {
      page
      records
      cashback_balance_locks {
        user {
          _id
          document_no
          name
        }
        unit {
          id_erp
          name
        }
        locked_by
        locked_value
        transaction_id
        locked_at
      }
    }
  }
`

export const QUERY_GET_CASHBACK_BALANCE_LOCKS_CONVERTER = gql`
  {
    cashbackBalanceLocks(pageSize: 9999, page: 1, lockedBy: converter) {
      records
    }
  }
`

export const MUTATION_RELEASE_CASHBACK_BALANCE_LOCK = gql`
  mutation ReleaseCashbackBalanceLock($document_no: String!) {
    releaseCashbackBalanceLock(document_no: $document_no)
  }
`

export const MUTATION_RELEASE_CASHBACK_BALANCE_LOCK_AND_CONSUME_BALANCE = gql`
  mutation ReleaseCashbackBalanceLockAndConsumeBalance($document_no: String!) {
    releaseCashbackBalanceLockAndConsumeBalance(document_no: $document_no)
  }
`

export const SEARCH_USER_QUERY = gql`
  query UserSearch($document_no: String) {
    user(document_no: $document_no) {
      _id
      document_no
      name
    }
  }
`

export const SEARCH_USER_CASHBACK_QUERY = gql`
  query GetCashbackByUserId($_id: String!) {
    getCashbackByUserId(_id: $_id) {
      _id
      activated_amount
      inactivated_amount
      consumed_amount
      updated_at
    }
  }
`

export const MUTATION_ADJUST_CASHBACK = gql`
  mutation AdjustCashback($user_id: String!, $adjustment_amount: Float!, $adjustment_reason: String!, $expires_at: DateTime) {
    adjustCashback(user_id: $user_id, adjustment_amount: $adjustment_amount, adjustment_reason: $adjustment_reason, expires_at: $expires_at) {
      _id
    }
  }
`

export const MUTATION_CREATE_DISTRIBUTED_CASHBACK = gql`
  mutation CreateDistributedCashbackReport($emails: [String!]!, $fileFormat: FileFormatType, $filters: [JobCashbackFilterInput!]!) {
    createDistributedCashbackReport(emails: $emails, filters: $filters, fileFormat: $fileFormat) {
      fileUrl
      id
      payload {
        emails
        fileFormat
        filters {
          predicate
          type
          value
        }
      }
      state
    }
  }
`

export const MUTATION_CREATE_CONSUMED_CASHBACK = gql`
  mutation CreateConsumedCashbackReport($emails: [String!]!, $fileFormat: FileFormatType, $filters: [JobCashbackFilterInput!]!) {
    createConsumedCashbackReport(emails: $emails, filters: $filters, fileFormat: $fileFormat) {
      fileUrl
      id
      payload {
        emails
        fileFormat
        filters {
          predicate
          type
          value
        }
      }
      state
    }
  }
`

export const MUTATION_CASHBACK_ADJUSTMENTS_REPORT = gql`
  mutation CreateCashbackAdjustmentsReport($emails: [String!]!, $fileFormat: FileFormatType) {
    createCashbackAdjustmentsReport(emails: $emails, fileFormat: $fileFormat) {
      fileUrl
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`

export const MUTATION_BULK_ADJUST_CASHBACK = gql`
  mutation BulkAdjustCashback($file: Upload!, $columns: AdjustCashbackFileColumnsPositions!, $commit: Boolean, $emails: [String!]) {
    bulkAdjustCashback(file: $file, columns: $columns, commit: $commit, emails: $emails) {
      failure {
        failed_lines_examples {
          adjustment_amount
          adjustment_reason
          document_no
          expires_at
          line_no
          reason
        }
        total_failures
      }
      success {
        adjustments_to_be_made
      }
      total_number_of_lines
    }
  }
`

export const MUTATION_SEND_CASHBACK_BALANCE_ASYNC_JOB = gql`
  mutation CreateCashbackBalanceReport($emails: [String!]!, $fileFormat: FileFormatType) {
    createCashbackBalanceReport(emails: $emails, fileFormat: $fileFormat) {
      id
      payload {
        emails
        fileFormat
      }
      state
    }
  }
`
